import { initGSAP } from '@mono-activities/hooks'

initGSAP({ reduceMotion: true })

export { type GSAP, useGSAP } from '@mono-activities/hooks'
